import { render, staticRenderFns } from "./CommunityCommentsSearch.vue?vue&type=template&id=94ac3390&scoped=true&"
import script from "./CommunityCommentsSearch.vue?vue&type=script&lang=ts&"
export * from "./CommunityCommentsSearch.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityCommentsSearch.vue?vue&type=style&index=0&id=94ac3390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ac3390",
  null
  
)

export default component.exports